/**
 * @fileoverview Input/output schemas for world-species-ideation-v3.
 *
 * This agent generates ideas for species (creatures, races, flora).
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldSpeciesIdeaV3Schema, WorldSpeciesElementEnum } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldSpecies.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  targetElement: WorldSpeciesElementEnum.optional().describe(
    'Optional filter to generate only a specific element type (creature, race, or flora). If not provided, generates a mix.'
  ),
});

export type Input = z.infer<typeof InputSchema>;

const WorldSpeciesIdeaOutputSchema = WorldSpeciesIdeaV3Schema.omit({
  tempId: true,
  source: true,
});

export const OutputSchema = z.object({
  species: z.array(WorldSpeciesIdeaOutputSchema).describe('An array of generated world species ideas.'),
});

export type Output = z.infer<typeof OutputSchema>;
